import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_private/employees/$employeeId/")({
  component: () => {
    const { employeeId } = Route.useParams();
    return <Navigate to="/employees/$employeeId/igold-transactions" params={{ employeeId }} replace />;
  },
});
